// extracted by mini-css-extract-plugin
module.exports = {"projects_card_main":"ProjectCard_projects_card_main__280qu"};